const menu = {
  init: () => {
      $('.menu-item-parent').on('mouseenter', function() {
          let $this = $(this);
          let id = $this.data('name');
       
          $('.image-box-inside img').removeClass('active');
          $(`.image-box-inside img[data-name="${id}"]`).addClass('active');
      });

      const el = document.querySelector('.image-box-inside img.active');
      if(el == undefined) document.querySelector('.image-box-inside img').classList.add('active');
  }
}

